// extracted by mini-css-extract-plugin
export default {"error":"ErrorAction_error__ZSMNj"};